import React from 'react';
import { Helmet } from 'react-helmet';

function Terms_and_Conditions_Seo() {
  return (
    <div>
      <Helmet>
                <title>Terms And Conditions | Ifepay</title>
                <meta name="description" content="Just some legal stuff, please read before your signup. We assure you we will become your preferred Money Transfer service provider for Nigeria." />
                <meta property="og:title" content="Terms And Conditions | Ifepay" />
                <meta property="og:description" content="Just some legal stuff, please read before your signup. We assure you we will become your preferred Money Transfer service provider for Nigeria." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/terms-and-conditions"/>
            </Helmet>
    </div>
  )
}

export default Terms_and_Conditions_Seo
